import { render, staticRenderFns } from "./Precos.vue?vue&type=template&id=be59642e&scoped=true"
import script from "./Precos.vue?vue&type=script&lang=js"
export * from "./Precos.vue?vue&type=script&lang=js"
import style0 from "./Precos.vue?vue&type=style&index=0&id=be59642e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be59642e",
  null
  
)

export default component.exports